import { flow } from 'fp-ts/function';
import { entries, isEmpty, map } from 'lodash/fp';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { IconName } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { getCurrentEnterpriseCustomLinks } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { getCustomLinkShortcutTooltipOnIndex } from '../../shortcuts';
import { createListItem } from '../helpers';
import { SidebarExpandableListItem, SidebarFontIcon } from '../style';
import StyledSidebarLink from '../StyledSidebarLink';

const mapCustomLinks = flow(
    entries,
    map(([index, { url, name, id }]) => {
        // @ts-expect-error $TSFixMeError: Argument of type 'string' is not assignable to parameter of type 'number'.
        const tooltip = getCustomLinkShortcutTooltipOnIndex(index);
        return (
            <StyledSidebarLink key={id} href={url} target="_blank">
                {createListItem({ text: name, iconName: IconName.CustomLink, tooltip })}
            </StyledSidebarLink>
        );
    })
);

const LinkMenu = ({ customLinks, ...other }: $TSFixMe) =>
    !isEmpty(customLinks) ? (
        <SidebarExpandableListItem
            leftIcon={<SidebarFontIcon value={IconName.CustomLink} />}
            primaryText={<LocalizedText textKey={TextKey.CustomLinkPlural} />}
            {...other}
        >
            {mapCustomLinks(customLinks)}
        </SidebarExpandableListItem>
    ) : null;

export default connect(
    createStructuredSelector({
        customLinks: getCurrentEnterpriseCustomLinks,
    })
)(LinkMenu);
